<template>
<div>
    <!-- :style="{'margin': data.code ? '0px 0px 12px 0px' : '0px 0px 12px 0px'}" -->
    <div 
        style="
            display: flex;
            justify-content: space-between;
            text-align: center;
            margin: 0px 0px 12px 0px;
            "
        >
        <div style="
                display: inline-block;
                padding: 6px 0px 6px 0px;
                vertical-align: middle;
                margin: auto 0px auto 0px;
            ">
            <span v-if="data.name" style="
                font-size: 15px;
                font-weight: bold;
                font-family: var(--font-acumin-pro-regular);
                letter-spacing: -0.22px;
                color: #236A51;
                margin-right: 16px">
                {{ data.name }}
            </span>
            <span v-if="data.type" style="
                font-size: 15px;
                font-weight: bold;s
                font-family: var(--font-acumin-pro-regular);
                letter-spacing: -0.22px;
                color: #808184;"
            >
                {{ data.type }}
            </span>
            <span v-if="data.parameterType" style="
                font-size: 12px;
                font-weight: 300;
                font-family: var(--font-acumin-pro-light);
                letter-spacing: -0.17px;
                color: #808184;
                margin-left: 8px"
            >
                {{ data.parameterType }}
            </span>
        </div>
        <div v-if="data.code" style="
                display: inline-block;
                background: #EEEEEE;
                padding: 6px 6px 6px 6px;
                vertical-align: middle;
                margin: auto 0px auto 0px;
                border-radius: 12px !important;
            ">
            <div style="background: #EEEEEE 0% 0% no-repeat padding-box;
                border-radius: 12px;
                width: 160px;
                height: auto; 
                text-align: center;
                font-size: 15px;
                font-weight: 300;
                letter-spacing: -0.22px;
                color: #808184;
                word-wrap: break-word;
                font-family: var(--font-acumin-pro-light);
            ">
                {{ data.code }}
            </div>
        </div>
        <div v-if="$slots.code" style="
                display: inline-block;
                background: #EEEEEE;
                padding: 6px 6px 6px 6px;
                vertical-align: middle;
                margin: auto 0px auto 0px;
                border-radius: 12px !important;
            ">
            <div style="background: #EEEEEE 0% 0% no-repeat padding-box;
                border-radius: 12px; width: 160px;
                height: auto;
                text-align: center;
                padding: 6px 0px 6px 0px;
                font-size: 15px;
                font-weight: 300;
                letter-spacing: -0.22px;
                color: #808184;
                word-wrap: break-word;
                font-family: var(--font-acumin-pro-light);
            ">
                <!-- SLOT CODE -->
                <slot name="code"></slot>
            </div>
        </div>
    </div>
    <div v-if="data.description" style="
        font-size: 15px;
        font-weight: 300;
        letter-spacing: -0.22px;
        color: #808184;
        font-family: var(--font-acumin-pro-light);"
        :style="{'margin': data.required ? '0px 0px 16px 0px' : ''}"
    >
        <div style="word-wrap: break-word;" v-html="data.description">
        </div>
    </div>
    <div v-if="$slots.description" class="description-slot" :style="{'margin': data.required ? '0px 0px 16px 0px' : ''}">
        <!-- SLOT DESCRIPTION -->
        <slot name="description"></slot>
    </div>
    <div v-if="data.required" style="margin: 0px 0px 4px 0px;">
        <span style="
            font-size: 15px;
            font-weight: bold;
            font-family: var(--font-acumin-pro-regular);
            letter-spacing: -0.22px;
            color: #808184;"
        >
            Requerido:
        </span>
        <span style="
            font-size: 15px;
            font-weight: 300;
            font-family: var(--font-acumin-pro-light);
            letter-spacing: -0.22px;
            color: #808184;"
        >
            {{ data.required }}
        </span>
    </div>
    <div v-if="data.defaultValue">
        <span style="
            font-size: 15px;
            font-weight: bold;
            font-family: var(--font-acumin-pro-regular);
            letter-spacing: -0.22px;
            color: #808184;"
        >
            Valor por defecto:
        </span>
        <span style="
            font-size: 15px;
            font-weight: 300;
            font-family: var(--font-acumin-pro-light);
            letter-spacing: -0.22px;
            color: #808184;"
        >
            {{ data.defaultValue }}
        </span>
    </div>
</div>
</template>
<script>
export default {
    name: 'InfoContent',
    props: {
        data: {
            type: Object,
            default: () => ({ 'name': 'hostname', 'type': 'String', 'parameterType': 'Path parameter', 'code': 'www.kymabank.com', 'description': 'Nombre o dirección asignada al servidor en el cual se encuentra instalado el microservicio al cual pertenece este métod. Identificador del banco afiliado al canal. Caracteres permitidos(expresión regular): \\\<span>b(6003)\\\</span>b', 'required': 'Sí', 'defaultValue': 'Valor por defecto: N/A' })
        },
        name: {
            type: String,
            default: 'Bank'
        },
        type: {
            type: String,
            default: 'String'
        },
        parameterType: {
            type: String,
            default: ''
        },
        code: {
            type: String,
            default: '6003'
        }
    }
}
</script>
<style>
.description-slot {
    font-size: 15px;
    font-weight: 300;
    letter-spacing: -0.22px;
    color: #808184;
    font-family: var(--font-acumin-pro-light);
    p {
        font-size: 15px !important;
        font-weight: 300 !important;
        letter-spacing: -0.22px !important;
        color: #808184 !important;
        font-family: var(--font-acumin-pro-light) !important;
    }
}
</style>
